import React from 'react'
import Card from '../../../common/Card'
import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import Highcharts from "@material-ui/core/es/styles/withStyles";

HighchartsMore(ReactHighcharts.Highcharts);


var config =  {
    chart: {
        type: 'bubble',
        plotBorderWidth: 0,
        zoomType: 'xy'
    },

    legend: {
        enabled: false
    },

    title: {
        text: 'Distribuição dos ciclos'
    },


    xAxis: {

        gridLineWidth: 0,
        title: {
            text: '#Dia'
        },
        labels: {
            format: '{value} dia'
        }
    },

    yAxis: {
        startOnTick: false,
        endOnTick: false,
        title: {
            text: 'Hora do dia'
        },
        labels: {
            format: '{value}h'
        },
        reversed: true
    },

    tooltip: {
        useHTML: true,
        headerFormat: '<table>',
        pointFormat: '<tr><th colspan="2"><h3>Horario: {point.y}</h3></th></tr>' +
            '<tr><th>#Dia:</th>:</th><td>{point.x}</td></tr>' +
            '<tr><th>Horario:</th><td>{point.y}h</td></tr>' +
            '<tr><th>Ciclos:</th><td>{point.z}</td></tr>',
        footerFormat: '</table>',
        followPointer: true
    },

    plotOptions: {
        series: {
            dataLabels: {
                enabled: true,
                format: '{point.z}'
            }
        }
    },

    series: [{
        data: [
        ]
    }]

}

export default function RaspaCycleDistributionOnHourChart(prop) {
    const { series, filter } = prop;
    if (series) {
        let categories = [];
        let cyclesarray = [];

        series.map(i => {
            let d = new Date(i.Data);
            let dh = d.getHours() * -1  ;
            let ddate = d.toISOString().slice(0,10);

            var timeDiff = Math.abs(d.getTime() - new Date(filter.periodMin).getTime() );
            var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24)) +1;

            cyclesarray.push(  { x: diffDays, y: i.Hora, z: i.Total, name: i.Data, country: i.Data}  );
           // cyclesarray.push( [  diffDays, i.Hora * -1 ]  );
        })

        config = {
            ...config,
            series: [
                {
                    data: cyclesarray
                }
            ]
        }
    }


    return (
        <Card title="laos">
            <ReactHighcharts config = {config}>
            </ReactHighcharts>
        </Card>
    )
}
